import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2e0e6094"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title_wrap" }

import { toRefs } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    title: String,
    titleMargin: String,
},
  setup(__props) {

const props = __props;



const num = [1,2,3,4,5];

const { title, titleMargin } = toRefs(props);



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(num.reverse(), (item) => {
      return (_openBlock(), _createElementBlock("span", {
        key: item,
        style: _normalizeStyle({ padding: `${(item + 4) * 0.5}px`}),
        class: "title_circle"
      }, null, 4))
    }), 128)),
    _createElementVNode("span", {
      class: "title_name",
      style: _normalizeStyle({margin: _unref(titleMargin)})
    }, _toDisplayString(_unref(title)), 5),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(num.reverse(), (item) => {
      return (_openBlock(), _createElementBlock("span", {
        key: item,
        style: _normalizeStyle({ padding: `${(item + 4) * 0.5}px`}),
        class: "title_circle"
      }, null, 4))
    }), 128))
  ]))
}
}

})